/* eslint max-len:0 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * YouTubeIcon Return the youtube icon as a functional Component
 *
 * @param {String} altText for svg alt
 * @returns {Function} icon svg
 * @public
 */
function YouTubeIcon({ altText }) {
  // eslint-disable-next-line max-len
  return (
    <svg role='img' title={ altText } xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <path d='M21.58 7.15a2.51 2.51 0 0 0-1.77-1.77C18.25 5 12 5 12 5s-6.25 0-7.81.43a2.51 2.51 0 0 0-1.77 1.72A26.28 26.28 0 0 0 2 12a26.28 26.28 0 0 0 .42 4.85 2.51 2.51 0 0 0 1.77 1.77c1.56.43 7.81.43 7.81.43s6.25 0 7.81-.43a2.51 2.51 0 0 0 1.77-1.77A26.28 26.28 0 0 0 22 12a26.28 26.28 0 0 0-.42-4.85zM10 15V9l5.23 3z'/>
    </svg>
  );
}

YouTubeIcon.propTypes = {
  altText: PropTypes.string.isRequired
};

export default YouTubeIcon;
